import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=ec5694f8&scoped=true&"
import script from "./ui-button.vue?vue&type=script&lang=js&"
export * from "./ui-button.vue?vue&type=script&lang=js&"
import style0 from "./ui-button.vue?vue&type=style&index=0&id=ec5694f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5694f8",
  null
  
)

export default component.exports